module.exports = require('./helpers/bundle-url').getBundleURL('fp6dw') + "logo.c51670a8.svg";